/**
 * Proxy for MyOrange interface, which is subject to change
 */
export default class MyOrangeInterface {
  /**
   * @return {boolean}
   */
  static get isClipboardInterfaceAvailable() {
    return window.NativeAndroid?.writeToClipboard !== undefined;
  }

  /**
   * Copy text to clipboard within the MyOrange webview
   *
   * @param {string} text
   */
  static writeToClipboard(text) {
    if (MyOrangeInterface.isClipboardInterfaceAvailable) {
      window.NativeAndroid?.writeToClipboard(text);
    }
  }

  /**
   * @return {boolean}
   */
  static get isMasterSnInterfaceAvailable() {
    return window.MobileNativeInterface?.notifyMasterSNChanged !== undefined;
  }

  /**
   * Report that Master SN was changed to MyOrange, so they can display a pop-up informing user
   * they need to log out to apply the change
   */
  static reportMasterSnChange() {
    if (MyOrangeInterface.isMasterSnInterfaceAvailable) {
      window.MobileNativeInterface.notifyMasterSNChanged();
    }
  }

  /**
   * Check for presence of any MyOrange interface
   *
   * @return {boolean}
   */
  static get isAnyMyOrangeInterfaceAvailable() {
    return (
      MyOrangeInterface.isClipboardInterfaceAvailable ||
      MyOrangeInterface.isMasterSnInterfaceAvailable
    );
  }
}
